import { api } from "../../utils/api";
import { banks } from "../../utils/banks";

const obterNomeBanco = (codigoBanco) => {
  const bancoEncontrado = banks.find(
    (bancosOrdenados) => bancosOrdenados.value === codigoBanco
  );
  return bancoEncontrado ? bancoEncontrado.label : codigoBanco;
};

export const getAccount = async () => {
  const response = await api.get(`current-account`);
  // console.log("Raw data: ", response.data);
  const data = response.data.map((dado) => ({
    id: dado.id,
    name_bank: obterNomeBanco(dado.bank),
    bank: dado.bank,
    agency: dado.agency,
    agency_digit: dado.agency_digit,
    account_number: dado.account_number,
    account_digit: dado.account_digit,
    days_to_clean: dado.days_to_clean,
    wallet: dado.wallet,
    idCompany: dado.company?.id || '',
    nameCompany: dado.company?.name || '',
    opening_balance: dado.opening_balance,
    agencyAndDigit: dado.agency + " / " + dado.agency_digit,
    accountNumberAndDigit: dado.account_number + " / " + dado.account_digit,
  }));
  // console.log("Formatted Data: ", data);
  return data;
};
